import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ProcessStepModel } from '../../process.model';
import * as Defaults from '../../default-process-fields';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.service';
import {
  selectProcess,
  selectStepById,
} from '../../selectors/process.selectors';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mj-process-hired',
  templateUrl: './process-hired.component.html',
  styleUrls: ['./process-hired.component.scss'],
})
export class ProcessHiredComponent implements OnInit, OnDestroy {
  @Input() stepOpenedUuid$;
  @Input() stepId: number;
  @Output() processChanged = new EventEmitter();
  allSteps: ProcessStepModel[];
  defaults = Defaults;
  step: ProcessStepModel;
  hiredMailChecked: boolean;
  message: FormControl;

  isStepActive: boolean;

  stepsToDisplay;
  private step$: Subscription;

  constructor(
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    this.translate
      .get('step_hired_message')
      .pipe(take(1))
      .subscribe(msg => {
        this.message = new FormControl(msg);
      });
  }

  ngOnInit(): void {
    this.step$ = this.store
      .pipe(select(selectStepById(this.stepId)))
      .subscribe(data => {
        if (data) {
          this.step = data;
          if (
            this.step.actions.length &&
            this.step.actions[0].message &&
            this.message.value !== this.step.actions[0].message
          ) {
            this.message.patchValue(this.step.actions[0].message);
          }
          this.hiredMailChecked =
            this.step.actions[0] && this.step.actions[0].enabled;
        }
      });

    this.store
      .pipe(
        select(selectProcess),
        take(1)
      )
      .subscribe(process => {
        this.allSteps = process.steps.filter(
          step => step.type !== 1 && step.type !== 5 && step.type !== 6
        );

        this.stepsToDisplay = [...this.allSteps];

        this.stepsToDisplay.splice(
          this.stepsToDisplay.findIndex(e => e.type === 0),
          1
        );

        // remove previously saved application step
        if (this.step.actions.length === 4) {
          this.removeApplicationStep();
        }

        // assign default messages
        if (this.step.actions.length < 3) {
          this.assignDefaultActions();
        }
      });
    this.stepOpenedUuid$.subscribe(uuid => {
      this.isStepActive = uuid === this.step.uuid;
    });
  }

  ngOnDestroy(): void {
    if (this.step$) {
      this.step$.unsubscribe();
    }
  }

  updateAction() {
    const newArr = this.step.actions.map(action => {
      return {
        ...action,
        enabled: this.hiredMailChecked,
        message: this.message.value,
      };
    });
    this.processChanged.emit({
      id: this.stepId,
      changes: { actions: newArr },
    });
  }

  getStepName(uuid) {
    const step = this.allSteps.find(elem => elem.uuid === uuid);
    if (step) {
      return this.defaults.StepsNames[step.type];
    } else {
      return uuid;
    }
  }

  removeAction(action) {
    const newActions = [...this.step.actions];
    const id = newActions.findIndex(
      elem => elem.previous_step_uuid === action.previous_step_uuid
    );
    newActions.splice(id, 1);
    this.processChanged.emit({
      id: this.stepId,
      changes: { actions: newActions },
    });
  }

  assignDefaultActions() {
    let newActions = [];

    this.stepsToDisplay.forEach(step => {
      if (
        this.step.actions.findIndex(
          action => action.previous_step_uuid === step.uuid
        ) === -1
      ) {
        newActions.push({
          id: null,
          previous_step_uuid: step.uuid,
          enabled: true,
          dismissible: true,
          message: this.message.value,
        });
      }
    });

    newActions = [...newActions, ...this.step.actions];

    this.processChanged.emit({
      id: this.stepId,
      changes: { actions: newActions },
    });
  }

  removeApplicationStep() {
    const appStepAction = this.allSteps.find(e => e.type === 0);
    const appStepActionId = this.step.actions.findIndex(
      e => e.previous_step_uuid === appStepAction.uuid
    );

    if (appStepActionId !== -1) {
      const newArr = [this.step.actions];
      newArr.splice(appStepActionId, 1);
      return this.processChanged.emit({
        id: this.stepId,
        changes: { actions: newArr },
      });
    }
  }
}
